<template>
  <div style="position: relative;">
    <el-form ref="QueryPaIndexModel" :model="formData" class="full-width-input" style="width: 100%;"
             label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="18" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>指标模型列表</span>
              <div class="base-card-operation">
              </div>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paIndexModel" :data="QueryPaIndexModel.PaIndexModel.impl.dataList" :size="defaultFormItemSize" @sort-change="QueryPaIndexModel.PaIndexModel.impl.onSortChange"
                          header-cell-class-name="table-header-gray"
                          highlight-current-row @current-change="QueryPaIndexModel.PaIndexModel.impl.currentRowChange"
                          @row-click="handleRowClick" row-key="id" default-expand-all height="600px"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="QueryPaIndexModel.PaIndexModel.impl.getTableIndex" />
                  <el-table-column label="名称" prop="name" width="250px">
                  </el-table-column>
                  <el-table-column label="类型" prop="typeDictMap.name">
                  </el-table-column>
                  <el-table-column label="启用条件" prop="enableCondition">
                  </el-table-column>
                  <el-table-column label="参数变量" prop="paramVariable">
                  </el-table-column>
                  <el-table-column label="指标值" prop="indexValue">
                  </el-table-column>
                  <el-table-column label="备注" prop="remark">
                  </el-table-column>
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                                 :disabled="!checkPermCodeExist('PaIndexModelManage:QueryPaIndexModel:delete')">
                        删除
                      </el-button>
                      <el-button @click="onAddPaIndexModelClick(scope.row)" type="text" :size="defaultFormItemSize" v-show="scope.row.type==='project'&&scope.row.id!==0"
                                 :disabled="!checkPermCodeExist('PaIndexModelManage:QueryPaIndexModel:AddPaIndexModel') || !addPaIndexModelEnabled">
                        添加
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="6" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>指标信息</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col :span="24">
                <EditPaIndexModel ref="editPaIndexModel"
                                  v-if="checkPermCodeExist('EditPaIndexModel')"
                                  :id="(QueryPaIndexModel.PaIndexModel.impl.currentRow || {}).id"
                                  @submit="onEditPaIndexModelSubmit"
                />
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList, treeDataTranslate} from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { PaIndexModelController, DictionaryController } from '@/api';
import addPaIndexModel from '@/views/PaIndex/addPaIndexModel.vue';
import EditPaIndexModel from '@/views/PaIndex/editPaIndexModel.vue';

export default {
  name: 'PaIndexModelManage',
  props: {
    name: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  components: {
    EditPaIndexModel
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: 1,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        }
      },
      QueryPaIndexModel: {
        formFilter: {
        },
        formFilterCopy: {
        },
        PaIndexModel: {
          impl: new TableWidget(this.loadPaIndexModelWidgetData, this.loadPaIndexModelVerify, false, true, 'sort', 1)
        },
        PaIndexModelDiv: {
          isInit: false
        },
        EditPaIndexModelDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paIndexModel.clearSelection();
      }
      this.$refs.paIndexModel.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 绩效指标模型数据获取函数，返回Promise
     */
    loadPaIndexModelWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paIndexModelDtoFilter: {
          searchString: this.name
        }
      }
      return new Promise((resolve, reject) => {
        PaIndexModelController.list(this, params).then(res => {
          let dataList = res.data.dataList;
          for (let i = 0; i < dataList.length; i++) {
            if (dataList[i].type !== 'index') {
              // dataList[i].levelCodeDictMap.name = '';
              // dataList[i].detail = '';
            }
            if (dataList[i].gcode === 'pa_work') {
              dataList[i].detail = '';
            }
          }
          resolve({
            dataList: treeDataTranslate(dataList, 'id', 'pid'),
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.QueryPaIndexModel.PaIndexModel.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.QueryPaIndexModel.PaIndexModel.impl.currentRow.id, 'id');
              this.$refs.paIndexModel.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 绩效指标模型数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaIndexModelVerify () {
      return true;
    },
    /**
     * 自定义组件编辑指标模型提交方法
     */
    onEditPaIndexModelSubmit (code) {
      if (code) {
        // 自定义组件提交后刷新当前fragment，如果不需要刷新数据，请在这里修改这里
        this.refreshQueryPaIndexModel();
      }
    },
    /**
     * 更新指标模型列表
     */
    refreshPaIndexModelDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.QueryPaIndexModel.PaIndexModel.impl.refreshTable(true, 1);
      } else {
        this.QueryPaIndexModel.PaIndexModel.impl.refreshTable();
      }
      this.QueryPaIndexModel.PaIndexModelDiv.isInit = true;
    },
    /**
     * 更新指标模型管理
     */
    refreshQueryPaIndexModel (reloadData = false) {
      if (reloadData) this.$refs.editPaIndexModel.onResume();
      if (reloadData) {
        this.QueryPaIndexModel.PaIndexModel.impl.refreshTable(true, 1);
      } else {
        this.QueryPaIndexModel.PaIndexModel.impl.refreshTable();
      }
      if (!this.QueryPaIndexModel.isInit) {
        // 初始化下拉数据
      }
      this.QueryPaIndexModel.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      if (row.pid === -1 || row.pid === 1) {
        this.$message.error('删除失败!节点不能删除!');
        return;
      }
      if (row.children !== undefined && row.children.length > 0) {
        this.$message.error('删除失败!请先删除子项!');
        return;
      }

      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaIndexModelController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.QueryPaIndexModel.PaIndexModel.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    /**
     * 添加
     */
    onAddPaIndexModelClick (row) {
      row = (row || this.QueryPaIndexModel.PaIndexModel.impl.currentRow || {});
      if (row.type !== 'project') {
        this.$message.error('添加失败!不能添加子节点!');
        return;
      }
      let type = (row.pid === -1) ? 'project' : 'index';
      let params = {
        pid: row.id,
        type: type,
        gcode: row.code
      };
      let title = '添加指标';
      if (params.type === 'project') {
        title = '添加项目';
      }
      this.$dialog.show(title, addPaIndexModel, {
        area: '400px', offset: '10px'
      }, params).then(res => {
        this.refreshPaIndexModelDivWidget();
      }).catch(e => {});
    },
    onResume () {
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaIndexModel: {
          id: undefined,
          pid: undefined,
          type: undefined,
          code: undefined,
          gcode: undefined,
          name: undefined,
          detail: undefined,
          remark: undefined,
          sort: undefined,
          enableCondition: undefined,
          inputVariable: undefined,
          paramVariable: undefined,
          indexValue: undefined,
          verifyRule: undefined,
          evalFormula: undefined,
          taskCode: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          deletedFlag: undefined,
          paIndexGroup: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshQueryPaIndexModel();
    }
  },
  computed: {
    addPaIndexModelEnabled () {
      return this.QueryPaIndexModel.PaIndexModel.impl.currentRow != null;
    },
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.formInit();
  },
  watch: {
    // 绩效指标模型选择行数据变化
    'QueryPaIndexModel.PaIndexModel.impl.currentRow': {
      handler (newValue) {
      },
      immediate: true
    }
  }
}
</script>
